const PartnerRoute = {
  alias: 'partners',
  path: 'parceiros',
  component: () => import("@/views/partner/PartnerPage.vue"),
  name: 'Parceiros',
  meta: {
    spacingTop: true,
    solidBackground: true
  },
}

export default PartnerRoute;
